

































































import { Component, Vue } from 'vue-property-decorator';
import I18nLanguageTypeForm from '@/views/system/i18n-language-type-form.vue';
import { getLanguageTypeQueryList, languageTypeDelete } from '@/api/system/LanguageApi';

@Component({
  name: 'I18nLanguageTypeList',
  components: {
    I18nLanguageTypeForm
  }
})
export default class I18nLanguageTypeList extends Vue {
  // 表单搜索Model
  searchForm: any = {};
  // 列表加载状态
  tableLoading: boolean = false;
  // 语言资源列表
  languageResourceList: any[] = [];
  // 当前选中语言资源
  currentLanguage: any = {};
  // 语言id
  langId: string = '';

  // 是否显示新增/编辑语言资源弹窗
  i18nFormDiglogVisible: boolean = false;

  // 分页参数
  pageIndex: number = 1;
  // 每页大小
  pageSize: number = 10;
  // 总条数
  total: number = 0;

  /**
   * onMounted
   */
  mounted() {
    // 获取语言资源列表
    this.getLanguageResourceList();
  }

  /**
   * 搜索
   */
  handleSearch() {
    this.pageIndex = 1;
    this.getLanguageResourceList();
  }

  /**
   * 重置搜索
   */
  resetSearch() {
    // 置空搜索表单
    this.pageIndex = 1;
    this.searchForm = {};
    this.getLanguageResourceList();
  }

  /**
   * 获取语言资源列表
   */
  getLanguageResourceList() {
    let params = {
      ...this.searchForm,
      page: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
    };
    this.tableLoading = true;
    getLanguageTypeQueryList(params)
      .then((res: Record<any, any>) => {
        if (res.code == '1' && res.data) {
          this.languageResourceList = res.data;
          this.total = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      })
      .finally(() => {
        this.tableLoading = false;
      });
  }

  /**
   * 改变分页大小
   */
  changePageSize(pageSize: number) {
    this.pageSize = pageSize;
    this.getLanguageResourceList();
  }

  /**
   * 跳转至某页
   */
  changePage(page: number) {
    this.pageIndex = page;
    this.getLanguageResourceList();
  }

  /**
   * 打开语言资源编辑弹窗
   */
  openLanguageForm(row?: any) {
    if (row) {
      this.currentLanguage = row;
      this.langId = row.id;
    }
    this.i18nFormDiglogVisible = true;
  }

  /**
   * 删除语言资源
   * @param row
   */
  deleteLanguageTypeById(row?: any) {
    if (row) {
      this.currentLanguage = row;
      this.$confirm(this.$t('lang_whether_or_not_to_delete') as string, this.$t('lang_tips') as string, {
        confirmButtonText: this.$t('lang_determine_') as string,
        cancelButtonText: this.$t('lang_cancel_') as string,
        type: 'warning'
      })
        .then(() => {
          languageTypeDelete({ id: row.id })
            .then((res: Record<any, any>) => {
              if (res.code == '1') {
                this.$message.success(res.message);
                this.getLanguageResourceList();
              } else {
                this.$message.error(res.message);
              }
            })
            .finally(() => {});
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('lang_undeleted') as string
          });
        });
    }
  }
}
